import { render, staticRenderFns } from "./CreateUpdateCopy.vue?vue&type=template&id=255354fb&"
import script from "./CreateUpdateCopy.vue?vue&type=script&lang=js&"
export * from "./CreateUpdateCopy.vue?vue&type=script&lang=js&"
import style0 from "./CreateUpdateCopy.vue?vue&type=style&index=0&id=255354fb&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports